import { AutogenLayoutCommissionsProcessingHold } from "./autogen/AutogenLayoutCommissionsProcessingHold";
import { ModelRow } from "@mcleod/core";
import { TableRowDisplayEvent } from "@mcleod/components";
import { CommissionsProcessingUtil } from "./CommissionsProcessingUtil";
import { FilterPanel } from "@mcleod/dispatch";
import { CommissionsProcessingTaskFilter } from "./CommissionsProcessingTaskFilter";

export class CommissionsProcessingHold extends AutogenLayoutCommissionsProcessingHold {
    public filterPanel: FilterPanel;

    onLoad(): void | Promise<void> {
        this.filterPanel = new FilterPanel([CommissionsProcessingTaskFilter.ORDER_BILLED, CommissionsProcessingTaskFilter.OVERRIDE_RATE], this.tableCommissionsProcessing, this.panelTaskFilters);
        this.tableCommissionsProcessing.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            tableRow.forEveryChildComponent((component) => {
                CommissionsProcessingUtil.setTooltipContent(component, tableRow.data);
            });
            CommissionsProcessingUtil.setComponentDetails(tableRow);
        });
        this.tableCommissionsProcessing.doOnResolveRowEdit = (row) => {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
            return null;
        }
    }

    getLayoutBaseFilter(row: ModelRow): boolean {
        return row.get("ready_to_pay_flag") == "N";
    }
}
